<template>
  <page-tab
    :banner="banner"
    :breadcrumb="breadcrumb"
    :tabList="tabList"
    v-model="tabCurrent"
    @change="tabChange"
  >
    <div v-if="tabCurrent === 1">{{ pageData.company?.companyCulture }}</div>
    <div v-else class="about-content">
      <template v-if="tabCurrent === 2">
        <img
          :src="item"
          v-for="(item, i) in pageData.company.companyHonorPhoto &&
          pageData.company.companyHonorPhoto.split(',')"
          :key="i"
        />
      </template>
      <template v-if="tabCurrent === 3">
        <img
          :src="item"
          v-for="(item, i) in pageData.company.companyCertificationPhoto &&
          pageData.company.companyCertificationPhoto.split(',')"
          :key="i"
        />
      </template>
    </div>
  </page-tab>
</template>
<script>
import PageTab from "@/components/PageTab.vue";
import banner from "@/assets/images/banner/about.png";
import { getIndex } from "@/api/index";

export default {
  name: "About",
  components: {
    PageTab,
  },
  data() {
    return {
      banner,
      pageData: {},
      breadcrumb: [
        { name: "首页", path: "/" },
        { name: "走进华武", path: "" },
        { name: "公司介绍", path: "" },
      ],
      tabList: [
        { name: "公司介绍", id: 1 },
        { name: "公司荣誉", id: 2 },
        { name: "公司资质", id: 3 },
      ],
      tabCurrent: 1,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    tabChange(item) {
      this.breadcrumb[2].name = item.name;
    },
    getData() {
      getIndex().then((res) => {
        this.pageData = res.data;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.about-content {
  img {
    display: block;
    max-width: 100%;
    margin: 0 auto;
  }
}
</style>
